<template>
	<div
		class="my-1 summary-order-grid fontS14"
		v-if="existBilling"
	>
		<div>
			<billing-svg/>
		</div>
		<div class="line-height-2 d-flex flex-column">
			<h4 class="my-0 fontAvenirBold">Solicitud de factura</h4>
			<span class="fontS13">RUC: <span class="fontOpenBold">{{billingData.ruc}}</span></span>
			<span class="fontS13">Razón social: <span class="fontOpenBold">{{billingData.rzSocial}}</span></span>
			<span class="fontS13">Domicilio Fiscal: <span class="fontOpenBold">{{billingData.address}}</span></span>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

function existBilling() {
	if (this.billingData) {
		const { ruc, rzSocial, address } = this.billingData;
		return !!ruc && !!rzSocial && !!address;
	}
	return false;
}

export default {
	name: 'billing-data',
	components: {
		billingSvg: () => import('@/components/svg-components/billingSvg'),
	},
	computed: {
		...mapGetters([
			'billingData',
		]),
		existBilling,
	},
};
</script>




// WEBPACK FOOTER //
// billingData.vue?7cc25eb3